import { render, staticRenderFns } from "./BottomFooter.vue?vue&type=template&id=1dc96ca5&"
import script from "./BottomFooter.vue?vue&type=script&lang=js&"
export * from "./BottomFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports